import { FC, ReactElement } from 'react';

type ToggleProps = {
  id: string;
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

const Toggle: FC<ToggleProps> = ({ id, label, checked, disabled, onChange }: ToggleProps): ReactElement => {
  const trackWidth = 46;
  const trackHeight = 26;
  const pad = 2;
  const thumb = trackHeight - pad * 2;
  const translateX = trackWidth - pad * 2 - thumb;
  
  return (
    <div className="d-flex align-items-center justify-content-between gap-3" style={{ minHeight: 38 }}>
      <label htmlFor={id} className="form-label mb-0">
        {label}
      </label>
      
      <div className="d-inline-flex align-items-center">
        <input
          id={id}
          type="checkbox"
          className="visually-hidden"
          checked={checked}
          disabled={disabled}
          onChange={(event) => onChange(event.target.checked)}
        />
        
        <label
          htmlFor={id}
          className="d-inline-flex align-items-center"
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.6 : 1,
            borderRadius: 999,
            width: trackWidth,
            height: trackHeight,
            padding: pad,
            transition: 'background-color 120ms ease, border-color 120ms ease, box-shadow 120ms ease',
            background: checked ? 'var(--bs-primary)' : 'var(--bs-secondary-bg)',
            border: `1px solid ${checked ? 'var(--bs-primary)' : 'var(--bs-border-color)'}`
          }}
          aria-label={label}
        >
          <span
            aria-hidden="true"
            style={{
              width: thumb,
              height: thumb,
              borderRadius: 999,
              background: 'var(--bs-body-bg)',
              boxShadow: '0 1px 2px rgba(0,0,0,0.18)',
              transform: `translateX(${checked ? translateX : 0}px)`,
              transition: 'transform 140ms ease',
              display: 'inline-block'
            }}
          />
        </label>
      </div>
    </div>
  )
}

export default Toggle;